interface Config {
  docsUrl: string;
  staticAssetsUrl: string;
}

export const BaSeConfig: Config = {
  docsUrl: 'https://base-react.sebrae.com.br',
  staticAssetsUrl: 'https://base-estatico.sebrae.com.br',
};
